((app) => {
    app.constant("RequirementStatusOrder", [
        "Outstanding",
        "Incomplete",
        "Declined / Rejected",
        "Open",
        "Ordered",
        "Order",
        "Add",
        "Sent to client",
        "OPEN/PENDING",
        "Pending",
        "Submitted",
        "Received But Not Reviewed",
        "Received / Under Review",
        "Acknowledged",
        "Received",
        "Response Received - send again",
        "Hold",
        "Evaluated",
        "Requirement reviewed by the underwriter",
        "Reviewed",
        "Approved",
        "Approved / Accepted",
        "Waived",
        "In error",
        "Unable to evaluate",
        "Removed by Carrier",
        "Cancelled",
        "Satisfied",
        "Completed",
        "Other",
        "Issued",
        "Published",
        "Completed with warnings",
        "Document Unavailable",
        "PVT CSC Return all Statuses",
        "PVT Met At Lab"
    ]);
})(window.app);